import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import CloseIcon from './icons/CloseIcon'

const ModalContainer = styled.div`
  position: ${props => props.fixed ? 'fixed' : 'absolute'};
  top: 123px;
  left: 0;
  background: white;
  height: calc(100% - 123px);
  overflow-y: scroll;
  width: 100vw;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-top: 40px;
  flex-direction: column;
`
const ContentContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  margin-top: 55px;
`
const Title = styled.h1`
  font-family: 'Zilla Slab', serif !important;
  color: #555;
`
const CloseButton = styled(CloseIcon)`
  height: 51px;
  width: 51px;
  top: 0;
  bottom: 0;
  margin: auto 0;
  cursor: pointer;
  position: absolute;
  right: 10%;
`
const TitleContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  position: relative;
`
const Padding = styled.div`
  padding-bottom: 30px;
`

const FullscreenModal = ({ children, title, isOpen, onClose, fixed }) => {
  if (!isOpen) {
    return null
  } else {
    return (
      <ModalContainer fixed={fixed}>
        <TitleContainer>
          <CloseButton onClick={onClose} />
          <Title>{title}</Title>
        </TitleContainer>
        <Padding>
          <ContentContainer>
            {children}
          </ContentContainer>
        </Padding>
      </ModalContainer>
    )
  }
}

FullscreenModal.propTypes = {
  children: PropTypes.element.isRequired,
  isOpen: PropTypes.bool,
  title: PropTypes.string
}

export default FullscreenModal
